/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line import/no-extraneous-dependencies
import util from '@webfront-components-vue/sign-utils';
import { createParser } from 'eventsource-parser';
import cloneDeep from 'lodash/cloneDeep';
import { useSecretStore, useUserStore } from '../store';

const myHeaders = new Headers();
myHeaders.append('Content-Type', 'application/json');

const { VUE_APP_KEYID: keyId, VUE_APP_SECRET: secret } = process.env;

export const fetchSSE = async (url, data, signal, cb, method = 'POST') => {
  try {
    const obj = cloneDeep(data);
    const useUser = useUserStore();
    const useStore = useSecretStore();
    // context 不参与签名，否则会使url过长而导致报错
    if (obj.context) {
      delete obj.context;
    }
    if (!useUser.isLogin) {
      obj.token = useStore.token;
    }
    const signData = util.genParamV3(obj, secret, keyId, 'ai-ppt-web', 'aippt.web', '', '', '', '', '', '', '', '', useStore.yduuid);
    let urlParamStr = '';
    // eslint-disable-next-line guard-for-in
    for (const k in signData) {
      urlParamStr = urlParamStr ? urlParamStr + `&${k}=${encodeURIComponent(signData[k])}` : `?${k}=${encodeURIComponent(signData[k])}`
    }
    const requestUrl = `${url}${urlParamStr}`;
    const sseConfig = {
      method,
      signal,
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: 'follow',
      credentials: 'include',
    }
    if (method === 'GET') {
      delete sseConfig.body;
    }
    const resp = await fetch(
      requestUrl,
      {
        ...sseConfig,
      },
    );
    if (resp.status !== 200) {
      cb({ code: resp.status, msg: '网络错误，请稍后重试~' });
      return;
    }
    const respJson = resp.clone().json();
    respJson
      .then((res) => cb(res))
      .catch(() => {
        console.log('err');
      });
    const parser = createParser((event) => {
      if (event?.event === 'message') {
        cb(event)
      }
      if (event?.event === 'end') {
        cb(event)
      }
    });
    const reader = resp.body.getReader();
    while (true) {
      // eslint-disable-next-line no-await-in-loop
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      const str = new TextDecoder().decode(value);
      parser.feed(str);
    }
    reader.releaseLock();
  } catch (err) {
    console.log(err.name);
    if (err.name !== 'AbortError') {
      cb({ code: 500 });
    }
  }
};
